/* eslint-disable import/no-mutable-exports */
import React from 'react';
import { Box, Hide, Image } from '@chakra-ui/react';
import { LinkLogo } from '../../Headers/Basic/styles/Basic.styles';
import Logo from '../../Headers/Basic/conditionals/Logo/template';
import { TTemplate } from '@/helpers/createTemplate';
import { FlexAsideInfo } from '../styles/index';
import Subtitle from '../components/Subtitle';
import Title from '../components/Title';
import CTA from '../CTA';
import lamb from '../../../assets/puntgenie/images/mascots/lamp.png';
import { TPageSpecificContent } from '@/views/onboarding/services/onboarding.types';

const template = (pageSpecificContent: TPageSpecificContent): TTemplate => ({
  asideInfo: {
    wrapper: <FlexAsideInfo />,
    logo: {
      wrapper: <LinkLogo to="/" />,
      logo: <Logo />,
    },
    title: <Title id="onboarding.login.title" />,
    subtitle: (
      <>
        <Hide below="md">
          <Subtitle id="onboarding.login.subtitle" />
        </Hide>
        <Box mx={['0', null, '-8']}>
          <Image w={['50%', '100%']} m="auto" src={lamb} />
        </Box>
      </>
    ),
    cta: (
      <CTA
        messageId={pageSpecificContent.footerInfoId}
        href={pageSpecificContent.ctaHref}
        dataCy={pageSpecificContent.dataCy}
      />
    ),
  },
});

export default template;
